'use client'

interface ShareButtonsProps {
  entityId: string
  entityType: string
  title: string
  url?: string
  compact?: boolean
}

export default function ShareButtons({ entityId, entityType, title, url, compact = false }: ShareButtonsProps) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '')

  async function track(platform: string) {
    try {
      await fetch('/api/analytics/share', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ entityId, entityType, platform, url: shareUrl }),
      })
    } catch {}
  }

  function shareWhatsApp() {
    track('whatsapp')
    const msg = title + ' — ' + shareUrl
    window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank')
  }

  function shareCopy() {
    track('copy')
    navigator.clipboard.writeText(shareUrl).then(() => {
      alert('Link copied to clipboard!')
    })
  }

  function shareNative() {
    track('native')
    navigator.share?.({ title, url: shareUrl }).catch(() => shareCopy())
  }

  if (compact) return (
    <div style={{ display: 'flex', gap: 8 }}>
      <button onClick={shareWhatsApp} style={{ background: '#25D366', color: 'white', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>📲 Share</button>
      <button onClick={shareCopy} style={{ background: '#f5f5f3', color: '#555', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>🔗 Copy</button>
    </div>
  )

  return (
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      <button onClick={shareWhatsApp} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#25D366', color: 'white', border: 'none', borderRadius: 10, padding: '10px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
        📲 WhatsApp
      </button>
      <button onClick={shareCopy} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'white', color: '#555', border: '1px solid #e8e8e8', borderRadius: 10, padding: '10px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
        🔗 Copy Link
      </button>
      {'share' in navigator && (
        <button onClick={shareNative} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#f5f5f3', color: '#555', border: '1px solid #e8e8e8', borderRadius: 10, padding: '10px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          ↗ Share
        </button>
      )}
    </div>
  )
}
